import { Component, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { Utility } from "src/app/common/service/utility";
import { AllPlantsService } from "./allplants.service";

@Component({
    selector: 'allplants',
    templateUrl: './allplants.component.html',
    styleUrls: ['./allplants.component.scss']
})

export class AllPlantsComponent {

    materialLBValues: boolean[];    
    currentDate = new Date();
    materialLBValue: boolean;
    onsiteValues: boolean[];
    onsiteValue: boolean;
    isLoadPanelVisible: boolean = false;
    allPlantsReportData: any;
    readonly allowedPageSizes = [50, 100, 200];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    constructor(private notificationService: NotificationService, private allPlantsReportService: AllPlantsService, private utility: Utility) {
        this.materialLBValues = [true, false];
        this.materialLBValue = true;
        this.onsiteValues = [true, false];
        this.onsiteValue = true;        

        this.getAllPlantsReport(this.materialLBValue, this.onsiteValue);
    }

    filterChanged(e) {
        this.getAllPlantsReport(this.materialLBValue, this.onsiteValue);
    }

    getAllPlantsReport(merchantLB, onsite) {
        this.isLoadPanelVisible = true;
        this.allPlantsReportService.getAllPlantsReport(merchantLB, onsite).subscribe({
            next: compressedData => {
                var decompressedData = this.utility.decompressData(compressedData);
                this.allPlantsReportData = JSON.parse(decompressedData);
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching All Plants data", error);
            }
        });
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    exportExcel(e) {
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        this.dataGrid.instance.columnOption('productionFacilityId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AllPlantsData.xlsx');
                });
        }).then(() => {
            this.dataGrid.instance.columnOption('siteId', 'visible', false);
            this.dataGrid.instance.columnOption('productionFacilityId', 'visible', false);
        });
        e.cancel = true;
    }
}